import React__default from 'react';
import './Card.scss';

const Card = ({ children, className }) => (React__default.createElement("div", { "data-rev-component": 'card', className: className }, children));

export { Card };
//# sourceMappingURL=Card.js.map
